<app-masked-input
  [mask]="mask"
  [placeholder]="placeholder"
  [label]="label"
  [link]="link"
  [text]="text"
  [switchBtnText]="switchBtnText"
  [helperText]="helperText"
  [shouldShowErrors]="shouldShowErrors"
  [readonly]="readonly"
  [validationError]="validationError"
  [checkedState]="checkedState"
  [warningState]="warningState"
  [customErrors]="customErrors"
  [formControl]="control"
  (switchBtnClick)="switchBtnClick.emit($event)"
  (input)="dinCheckTrigger.next(null)"
/>

@if (showIncorrectDinMessage) {
  <div class="mt-2">
    <app-disclaimer
      color="orange"
      icon="ic-info-circle-20"
    >
      {{ incorrectDinMessage }}
    </app-disclaimer>
  </div>
}
